<template>
    <div>
        <div class="columns">
            <div class="column is-4">
                <span class="heading has-text-grey-dark">Search text</span>
                <div class="control has-icons-left">
                    <input v-model="search.query" class="input" type="text" placeholder="Search...">
                    <span class="icon is-small is-left">
                        <i class="fa fa-search"></i>
                    </span>
                </div>
            </div>
            <div class="column is-4">
                <span class="heading has-text-grey-dark">School</span>
                <div class="control has-icons-left">
                    <multiselect v-model="search.school" label="name" name="schools" track-by="id" :options="schools" placeholder="Choose school"></multiselect>
                </div>
            </div>
            <div class="column is-4">
                <span class="heading has-text-grey-dark">Status</span>
                <div class="control has-icons-left">
                    <multiselect v-model="search.status"  :options="statuses" placeholder="Status"></multiselect>
                </div>
            </div>
        </div>

        <table class="table is-hoverable is-bordered is-fullwidth">
            <thead>
                <tr>
                    <th v-for='col in columns' class="sortable" @click='sortBy(col.key)'>
                        {{col.name}}
                        <i class="fa fa-sort-up is-pulled-right" v-if="column == col.key && reverse"></i>
                        <i class="fa fa-sort-down  is-pulled-right" v-if="column == col.key && !reverse"></i>
                    </th>
                    <th v-if="actions">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" v-if="item.original">
                    <td>{{item.id}}</td>
                    <td>
                        <div class="control">
                            <b class="aquamarine">{{item.provider_full_id ? item.provider_full_id : item.provider_id}}</b> /
                            <b class="deeppink">{{item.original.provider_full_id ? item.original.provider_full_id : item.original.provider_id}}</b>
                        </div>
                    </td>
                    <td>
                        <div class="control">
                            <b class="aquamarine">{{item.name}}</b> /
                            <b class="deeppink">{{item.original.name}}</b>
                        </div>
                    </td>
                    <td>
                        <div class="control">
                            <b class="aquamarine">{{item.words}}</b> /
                            <b class="deeppink">{{item.original.words}}</b>
                        </div>
                    </td>
                    <td>{{item.status}}</td>
                    <td v-if="actions" width="10%">
                        <router-link v-bind:to="{ name: 'sb-lesson-changes-show', params: { lesson_id: item.original.lesson_id, id: item.id }}" class="button tooltip" data-tooltip="View">
                            <span class="icon">
                                <i class="fa fa-eye"></i>
                            </span>
                        </router-link>

<!--                        <button v-if="item.status == 'requested'" class="button is-primary tooltip" data-tooltip="Approve" @click="approve($event, item) ">
                            <span class="icon" data-tooltip="Approve">
                                <i class="fa fa-check"></i>
                            </span>
                        </button>

                        <button v-if="item.status == 'requested'" class="button is-danger tooltip" data-tooltip="Decline" @click="decline($event, item)">
                            <span class="icon" data-tooltip="Decline">
                                <i class="fa fa-times"></i>
                            </span>
                        </button>-->
                    </td>
                </tr>
            </tbody>
        </table>
        <bulma-pagination :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
    </div>
</template>

<script>

export default {
  name: 'sb-lessons-table',
  props: {
	    items: { required: true },
        page: { required: true },
        total: { required: false, default: 0 },
        actions: {required: false, default: false}
  },
  components: {},
  data() {
        return {
            search: {'query':'', school:{}, status:'requested'},
            statuses: ['requested', 'approved', 'declined'],
            column: 'id',
            columns: [
                {
                    name: '#',
                    key: 'id'
                },
                {
                    name: 'Provider id',
                    key: 'provider_id'
                },
                {
                    name: 'Name',
                    key: 'name'
                },
                {
                    name: 'Words',
                    key: 'words'
                },
                {
                    name: 'Status',
                    key: 'status'
                },
            ],
            reverse: true,
        }
  },
  created(){
      if(this.schools.length == 0){
          this.loadSchools();
      }
      this.search.school = this.MAGIC_EARS;
  },
  methods: {
    sortBy(column) {

        if(column != ''){
            if(this.column == column){
              this.reverse = !this.reverse;
            }
            else{
              this.column = column;
            }

            let direction = this.reverse ? "asc" : "desc";

            this.$emit("sort", this.column + "," + direction);
        }
    },
        onPageChanged(page){
            this.$emit("pageChanged", page);
        },
        show(lesson_id, id){
            this.$router.push('/dashboard/sb-lesson-changes/'+ lesson_id + '/' + id);
        },
      approve(event, item){
          event.stopPropagation();
          this.stbyLessonRepo.approveChanges(item).then(response => {
              this.$emit("approve", item.id);
              //this.$router.push('/dashboard/sb-lesson-changes');
          });
      },
      decline(event, item){
          event.stopPropagation();
          this.stbyLessonRepo.declineChanges(item).then(response => {
              this.$emit("decline", item.id);
              //this.$router.push('/dashboard/sb-lesson-changes');
          });
      },


  },
  watch: {
      'search.query': _.debounce(function(value){
        this.$emit("search", this.search);
      }, 800),

      'search.school'(value){
          this.$emit("search", this.search);
      },
      'search.status'(value){
          this.$emit("search", this.search);
      },
  },
  computed: {
  }
}
</script>

<style lang="css" scoped>
    .aquamarine{
        color: aquamarine;
    }
    .deeppink{
        color: deeppink;
    }
</style>



// WEBPACK FOOTER //
// src/components/sb-lesson-changes/Table.vue